var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconsDruck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 -2 17 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icons-druck") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons-druck"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.53125,16.53125 L16.53125,15.8125 C16.5306507,14.6133356 15.785817,13.5404887 14.6625,13.1207813 L11.140625,11.9377188",
    id: "Path",
    stroke: "#7F8BDB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.390625,11.9377188 L1.86875,13.1207813 C0.745432955,13.5404887 0.000599278163,14.6133356 0,15.8125 L0,16.53125",
    id: "Path",
    stroke: "#7F8BDB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4000938,5.175 L11.1557188,3.953125 C8.28071875,3.953125 8.28071875,2.515625 8.28071875,2.515625 L8.2210625,2.515625 C8.2210625,2.515625 8.2210625,3.953125 5.3460625,3.953125 L5.103125,5.175",
    id: "Path",
    stroke: "#7F8BDB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.173125,8.984375 C7.59645255,8.984375 8.07514005,9.12681769 8.6091875,9.41170308",
    id: "Path",
    stroke: "#7F8BDB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.546875,6.109375 C7.39176121,5.86635415 7.11560996,5.72827852 6.828125,5.75 C6.54064004,5.72827852 6.26448879,5.86635415 6.109375,6.109375",
    id: "Path",
    stroke: "#7F8BDB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.421875,6.109375 C10.2667612,5.86635415 9.99060996,5.72827852 9.703125,5.75 C9.41564004,5.72827852 9.13948879,5.86635415 8.984375,6.109375",
    id: "Path",
    stroke: "#7F8BDB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#7F8BDB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "6.45454545 23 7.81818182 18.6956522 6 18.6956522 7.36363636 14 11 14 8.72727273 17.1304348 11 17.1304348"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.265625,11.5 C9.26253125,11.5 11.4928125,10.2630312 11.8105,8.36265625 C11.849756,8.12663929 12.0038816,7.92562936 12.221625,7.82646875 C12.9964375,7.47428125 13.1905,6.06409375 12.5644688,5.75 C12.9238438,3.6038125 12.9238438,0 8.265625,0 C3.60740625,0 3.61028125,3.6038125 3.96678125,5.75 C3.34075,6.06409375 3.53553125,7.475 4.309625,7.82646875 C4.52736845,7.92562936 4.68149403,8.12663929 4.72075,8.36265625 C5.0384375,10.2630312 7.26871875,11.5 8.265625,11.5 Z",
    id: "Path",
    stroke: "#7F8BDB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "flash",
    transform: "translate(5.750000, 14.375000)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsDruck);
export default __webpack_public_path__ + "static/media/icons-druck.cad279ab510afb3626247ae451e80d06.svg";
export { ForwardRef as ReactComponent };